import type { EventEntry } from './event-entry'
import type { EventPrivacy } from './event-privacy'

type ConfirmationValues = { entry?: EventEntry | null; privacy?: EventPrivacy }

/** Guests confirm before they come: a Pulsify ticket, a Pulsify sign-up or an accepted request. */
export function hasConfirmationStep(values: ConfirmationValues, saved = false): boolean {
  return (
    saved || values.privacy === 'request' || values.entry === 'tickets' || values.entry === 'signup'
  )
}

/** `saved`: the saved event already has tickets or a sign-up; undefined while still loading. */
export function applyAddressVisibility<T extends ConfirmationValues & { addressHidden?: boolean }>(
  values: T,
  saved: boolean | undefined,
): T {
  if (!values.addressHidden) return values
  if (saved === undefined || hasConfirmationStep(values, saved)) return values
  return { ...values, addressHidden: false }
}
